<template lang="pug">
    div.meditationOuter
        div.meditation(:class="{mobile: isMobile, disabled: lockedMeditation, blur: blur}")
            div
                div.meditationImage(@click="play")

                    // Meditation Cover Image
                    img(v-lazy="coverImage")

                    // Meditation Status
                    div.statusItem
                        status-component.meditationListStatus(
                            v-if="item.type !== 'recorded' && statusBadge.statusText"
                            :class="statusBadge.statusClass"
                        ) {{ statusBadge.statusText }}

                        status-component.meditationListStatus(
                            v-if="isAdmin && item.isSuggested"
                            :class="statusBadge.statusClass"
                        ) Suggested

                    // Reminder
                    // TODO: Add verification on Member
                    reminder(
                        v-if="showReminder"
                        :id="item.id"
                        :hasReminder="item.hasReminder"
                        :startedAt="item.startedAt"
                    )

                    // Mobile version Play button
                    div.mobilePlayButton(v-if="isMobile && allowedTypesToPlay && !lockedMeditation")
                        v-btn.button(
                            color="white"
                            flat
                            icon
                            @click="play"
                        )
                            v-icon.icon play_arrow

                    // Desktop version Lock button
                    div.desktopPlayButton(v-if="lockedMeditation")
                        v-icon.icon lock

                    div.hoverContent.text-xs-center(v-if="!isMobile && !lockedMeditation")
                        div

                            // Meditation Title on hover
                            div
                                p.meditationTitle(v-line-clamp:22="2") {{ item.title }}

                            div(v-if="allowedTypesToPlay")

                                // Play button on hover
                                v-btn.button(
                                    color="white"
                                    flat
                                    icon
                                    @click="play"
                                )
                                    v-icon.icon play_arrow
                div.content
                    div.contentInner

                        // Meditation Title
                        div(@click="play")
                            div.meditationTitle(v-line-clamp:22="2")
                                span {{ item.title }}

                        // Meditation Date Start
                        div(v-if="item.type === 'planned' || item.type === 'recorded-live'")
                            span {{ `Available On: ` }}
                            span(v-if="item.check_in_duration === 0") {{ item.startedAt | formattedDateTime }}
                            span(v-else) {{ item | formattedDateTimeWithCheckIn }}

                        // Meditation Duration
                        div.meditationDuration(v-if="item.duration")
                            div {{ item.duration | timeCode }}
                            div
                                v-icon.ml-2(
                                    color="white"
                                    v-if="item.isWatched"
                                ) remove_red_eye
                            div
                                v-icon.ml-2(
                                    color="white"
                                    v-if="showClosedCaptions"
                                ) closed_caption

                    // Meditation Description on hover
                    div.hoverContent(v-if="!isMobile")
                        p.description(v-line-clamp:15="6") {{ item.description }}

            div

                // Horizontal line
                div.px-2
                    separator-component

                div.contentFooter

                    // Instructor Information
                    instructor(v-if="item.instructor && item.instructor.fullName" :instructor="item.instructor")

                    // Controls
                    controls(
                        :item="item"
                        :type="item.type"
                        :channel="item.channel"
                        :sessionId="item.id"
                        :startedAt="item.startedAt"
                    )
        div.share(v-if="isMember || isChampion")
            share-component(:item="item" :callbackFunction="setBlur")
</template>

<script>
    import VueTypes from 'vue-types';
    import Separator from '../Separator';
    import Reminder from './Reminder.vue';
    import Share from '../Share';
    import Status from '../Status';
    import formattedDateTime from '~filters/FormattedDateTime';
    import formattedDateTimeWithCheckIn from '~filters/FormattedDateTimeWithCheckIn';
    import timeCode from '~filters/timeCode';
    import { mapActions, mapGetters } from 'vuex';
    import Instructor from './Instructor';
    import Controls from './Controls';
    import dayjs from 'dayjs';

    export default {
        components: {
            Instructor,
            Controls,
            Reminder,
            StatusComponent: Status,
            SeparatorComponent: Separator,
            ShareComponent: Share
        },
        filters: {
            formattedDateTime,
            timeCode,
            formattedDateTimeWithCheckIn
        },
        props: {
            item: VueTypes.object.def({}),
            duration: VueTypes.number.def(0)
        },
        data() {
            return {
                blur: false
            };
        },
        computed: {
            ...mapGetters('auth', [
                'isAdmin',
                'isInstructor',
                'isMember',
                'isChallenge',
                'isChampion'
            ]),

            /**
             * Show reminder trigger
             */
            showReminder() {
                return this.item.type == 'planned' && !this.diffTime(this.item);
            },

            /**
             * Cover Image.
             * @returns {string}
             */
            coverImage() {
                if (this.item.poster) return this.item.poster;
                return `https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditations-cover-images/buildingImage.png`;
            },

            /**
             * Check is Locked Meditation.
             * @returns {boolean}
             */
            lockedMeditation() {
                return (
                    (this.item.isLocked && this.isMember) ||
                    (this.item.isLocked && this.isMember && this.isChallenge) ||
                    (this.item.businessSession &&
                        this.item.businessSession[0] &&
                        this.item.businessSession[0].isLocked)
                );
            },

            /**
             * Check is show Play button.
             * @returns {boolean}
             */
            allowedTypesToPlay() {
                const { type } = this.item;
                const diffTime = this.diffTime(this.item);

                if (type === 'processing') return false;

                return (
                    type === 'recorded' ||
                    type === 'live' ||
                    type === 'locked' ||
                    (type === 'planned' && diffTime) ||
                    (type === 'recorded-live' && diffTime)
                );
            },

            /**
             * Check screen resolution.
             * @returns {boolean}
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },

            /**
             * Show Join Meditation button.
             * @returns {boolean}
             */
            showJoinMeditation() {
                let currentDate = dayjs();
                let startedAt = dayjs(this.item.startedAt);
                let diffTime = startedAt.diff(currentDate, 'seconds');

                if (diffTime > 0 && diffTime <= 10 * 60) {
                    return true;
                } else if (diffTime >= -10 * 60 && diffTime < 0) {
                    return true;
                } else {
                    return false;
                }
            },

            /**
             * Meditation status
             */
            statusBadge() {
                let statusClass = null,
                    statusText = null;

                switch (this.item.type) {
                    case 'planned':
                        statusText = this.$t('sessions.list.status.planned');
                        break;

                    case 'recorded':
                        statusText = this.$t('sessions.list.status.recorded');
                        break;

                    case 'processing':
                        statusText = this.$t('sessions.list.status.processing');
                        break;

                    case 'recorded-live': {
                        const currentDate = dayjs();
                        const startedAt = dayjs(this.item.startedAt);
                        const diffTime =
                            startedAt.diff(currentDate, 'seconds') +
                            this.item.check_in_duration;

                        if (currentDate.isBefore(startedAt)) {
                            statusText = this.$t(
                                'sessions.list.status.planned'
                            );
                        } else if (
                            Math.abs(diffTime) <= this.item.aws_data.duration
                        ) {
                            statusClass = 'warningColor';
                            statusText = 'NOW';
                        } else {
                            statusText = this.$t(
                                'sessions.list.status.recorded'
                            );
                        }
                        break;
                    }
                    case 'live': {
                        const currentDate = dayjs();
                        const startedAt = dayjs(this.item.startedAt);
                        const diffTime =
                            startedAt.diff(currentDate, 'seconds') +
                            this.item.check_in_duration;
                        const isWithinCheckInInterval =
                            diffTime <= this.item.check_in_duration &&
                            diffTime > 0;

                        if (isWithinCheckInInterval) {
                            statusClass = 'warningColor wide';
                            statusText = this.$t(
                                'sessions.list.status.checkin'
                            );
                        } else {
                            statusClass = 'warningColor';
                            statusText = 'NOW';
                        }
                        break;
                    }

                    case 'meeting':
                        statusClass = 'meetingColor';
                        statusText = 'Meeting';
                        break;

                    case 'archived':
                        statusClass = 'primaryColor';
                        statusText = this.$t('sessions.list.status.archived');
                        break;

                    case 'locked':
                        statusClass = 'primaryColor';
                        statusText = this.$t('sessions.list.status.locked');
                        break;
                }

                return { statusClass, statusText };
            },

            /**
             * Show closed captions icon
             */
            showClosedCaptions() {
                return this.item.aws_data?.upstreamChannel?.subtitles?.length;
            }
        },
        methods: {
            ...mapActions('sessions', ['resetSession']),

            /**
             * Blur card toggle
             */
            setBlur(isActive) {
                this.blur = isActive;
            },

            /**
             * Allow to play meditation available less then 10 minutes
             */
            diffTime(item) {
                if (!this.item.startedAt) return true;
                let currentDate = dayjs(new Date());
                let startedAt = dayjs(item.startedAt);
                let diffTime = startedAt.diff(currentDate, 'milliseconds');

                if (diffTime <= 5 * 60 * 1000) {
                    return true;
                }
                return false;
            },

            /**
             * Play video
             */
            play() {
                const diffTime = this.diffTime(this.item);
                return this.openSession(diffTime);
            },

            openSession(diffTime) {
                if (
                    this.item.type === 'processing' ||
                    (this.item.isLocked &&
                        (this.isMember || this.isChampion)) ||
                    (this.item.businessSession &&
                        this.item.businessSession[0].isLocked &&
                        (this.isMember || this.isChampion)) ||
                    ((this.item.type === 'planned' ||
                        this.item.type === 'recorded-live') &&
                        !diffTime)
                ) {
                    return false;
                }

                if (this.item.type === 'recorded-live') {
                    this.$router
                        .push({
                            name: 'dashboard.sessions.view',
                            params: {
                                id: this.item.id,
                                duration: this.duration
                            }
                        })
                        .catch(err => {});
                    return;
                }

                this.$router
                    .push({
                        name: 'dashboard.sessions.view',
                        params: { id: this.item.id, duration: this.duration }
                    })
                    .catch(err => {});
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .meditationOuter
        position: relative
        box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
        border-radius: 10px
        height: calc(100% - 16px)
        min-height: 270px
        transition: filter .3s

    .meditation
        background-color: $theme.info
        margin-bottom: 16px
        height: 100%
        justify-content: space-between
        display: flex
        flex-direction: column
        border-radius: 10px
        overflow: hidden

        &.disabled
            background: rgba(2, 35, 65, .4)

            .meditationImage img
                opacity: 0.6

        &:not(.mobile) > div:hover

            .meditationImage img
                opacity: 0.6

            .hoverContent
                opacity: 1
                top: 0

            .content .contentInner
                opacity: 0

    .desktopPlayButton
        position: absolute
        width: 40px
        height: 40px
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        border: 1px solid #fff
        border-radius: 50%
        color: white
        text-align: center

        .icon
            color: white
            line-height: 40px
            font-size: 27px

    .mobilePlayButton
        position: absolute
        z-index: 2
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        background-color: rgba(0, 0, 0, 0.3)
        border-radius: 50%

        .button
            width: 40px
            height: 40px
            opacity: 1

        .icon
            font-size: 40px

    .content
        position: relative
        padding: 34px 8px 0
        font-size: 12px

    .description
        font-style: italic

    .description
    .meditationTitle
        word-break: normal !important

    .contentFooter
        padding: 0 8px 8px
        display: flex
        justify-content: space-between
        align-items: center

    .meditationTitle
        font-size: 22px
        line-height: 24px
        font-weight: 300
        margin-bottom: 5px

    .businesses
        margin-top: 10px
        margin-bottom: 15px
        text-overflow: ellipsis

        overflow: hidden
        white-space: nowrap

    .meditationImage
        position: relative
        overflow: hidden
        height: 150px

        img
            transition: opacity 0.3s
            min-width: 100%
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
            z-index: 1

    .meditationDuration
        font-size: 12px
        display: flex
        align-items: center

    .hoverContent
        position: absolute
        z-index: 2
        top: 20px
        left: 0
        width: 100%
        height: 100%
        padding: 8px
        opacity: 0
        transition: 0.3s

        & > div
            display: flex
            height: 100%
            flex-direction: column
            align-items: center
            justify-content: center

        .businesses
            margin: 0

        .icon
            color: $theme.white
            font-size: 34px

        button
            border-radius: 50%
            border: 1px solid #fff
            width: 40px
            height: 40px

    .statusItem
        position: absolute
        z-index: 2
        left: 5px
        top: 10px

        .wide
            width: 110px;

    .share
        position: absolute
        bottom: 6px
        right: 6px
        z-index: 2

    .blur
        filter: blur(3px)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .meditationOuter
            min-height: 0

        .meditationImage
            height: auto
            aspect-ratio: 16 / 9

            img
                width: 100%
                height: 100%
                object-fit: cover
                position: absolute
                top: 0
                left: 0
                transform: none

        .content
            padding: 8px 10px 2px

        .meditationTitle
            font-size: 16px
            line-height: 20px
            margin-bottom: 2px

        .px-2
            padding: 0 4px

        .contentFooter
            padding: 2px 10px 6px
</style>
